import { combineReducers } from 'redux';
import notifications from './notificationsReducer';
import questions from './questionsReducer';

const reduxApp = combineReducers({
  notifications,
  questions
});

export default reduxApp;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/index.js
 **/